export function convertToAmPm(time: string) {
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);

  const meridiem = hour >= 12 ? 'PM' : 'AM';
  const amPmHour = hour % 12 || 12;
  const amPmTime = `${amPmHour}:${minutes} ${meridiem}`;

  return amPmTime;
}

export function increaseHourByMinutes(time: string, minutes: number) {
  const [hours, originalMinutes] = time.split(':');

  let hour = parseInt(hours);
  let minute = parseInt(originalMinutes);

  // Tính toán tổng số phút mới
  const totalMinutes = hour * 60 + minute + minutes;

  // Tính toán giờ và phút mới
  hour = Math.floor(totalMinutes / 60) % 24;
  minute = totalMinutes % 60;

  // Định dạng lại chuỗi thời gian
  const increasedTime = `${String(hour).padStart(2, '0')}:${String(
    minute
  ).padStart(2, '0')}`;

  return increasedTime;
}

export const convertToUTCHours = (date: number) => {
  const hour = new Date(date * 1000).getUTCHours();
  const minute = new Date(date * 1000).getUTCMinutes();

  const viewHour = hour.toString().length == 1 ? `0${hour}` : hour;
  const viewMinute = minute.toString().length == 1 ? `0${minute}` : minute;

  return `${viewHour}:${viewMinute}`;
};
